import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postAPI } from '../../services/api.service';

interface RegisterData {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  terms: boolean;
    role: string;
}

export const useRegister = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleRegister = async (data: RegisterData) => {
    setLoading(true);
    // remove terms from data before sending to backend
    const { terms, ...rest } = data;
    try {
      const response = await postAPI('/auth/register', rest);
      if (response.status === 201) {
        toast.success('Registration successful! Please log in.');
        navigate('/login');
      } else {
        toast.error('Registration failed. Please try again.');
      }
    } catch (error) {
      toast.error('An error occurred during registration.');
    } finally {
      setLoading(false);
    }
  };

  return { handleRegister, loading };
};
